import classNames from 'classnames';
import React from 'react';
import { NO_DATA_FILTERS_MESSAGE } from './constants';
import styles from './NoData.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
  noHeader?: boolean;
  message?: string;
}

const NoData: React.FC<Props> = ({
  className,
  message = NO_DATA_FILTERS_MESSAGE,
  noHeader,
  ...rest
}) => (
  <div
    className={classNames(styles.noData, { [styles.noHeader]: noHeader }, className)}
    data-testid="widget_no_data_title"
    {...rest}
  >
    <h4>No data to display</h4>
    <p data-testid="widget_no_data_message">{message}</p>
  </div>
);

export default NoData;
